import { useRef, useEffect, useCallback } from 'react';
import SwiperCore, { Mousewheel, Scrollbar } from 'swiper';
import Image from 'next/image';
import { useMediaQuery } from 'react-responsive';
import styles from './design-slider.module.css';

import slide1 from '../../public/design/wireframing/s0-min.png';
import slide2 from '../../public/design/wireframing/s1-min.png';
import slide3 from '../../public/design/wireframing/s2-min.png';
import slide4 from '../../public/design/wireframing/s3-min.png';
import slide5 from '../../public/design/wireframing/s4-min.png';
import slide6 from '../../public/design/wireframing/s5-min.png';
import slide7 from '../../public/design/wireframing/s6-min.png';

SwiperCore.use([Mousewheel, Scrollbar]);

export default function DesignSlider() {
  const refWrapper = useRef<any>(null);
  const refList = useRef<any>(null);

  const isTab = useMediaQuery({
    query: '(max-width: 768px)',
  });

  const scrollHandle = useCallback(() => {
    const slides = refList.current.children;
    const sliderWidth =
      slides[0].getBoundingClientRect().width * slides.length +
      (slides.length - 1) * (isTab ? 17 : 36) +
      40;
    const winHeight = window.innerHeight;

    const heraSliderData = refWrapper.current.getBoundingClientRect();

    if (
      heraSliderData.bottom - winHeight <= 0 &&
      heraSliderData.bottom >= heraSliderData.height
    ) {
      refList.current.style.transform = `translateX(-${
        ((sliderWidth - heraSliderData.width) /
          (winHeight - heraSliderData.height)) *
        (winHeight - heraSliderData.height - heraSliderData.top)
      }px)`;
    }
  }, [refList, isTab]);

  useEffect(() => {
    if (refWrapper.current && refList.current) {
      window.addEventListener('scroll', scrollHandle);
    }
    return () => {
      window.removeEventListener('scroll', scrollHandle);
    };
  }, [refWrapper, refList, scrollHandle]);

  return (
    <div ref={refWrapper} className={styles.wrapper}>
      <ul ref={refList} className={styles.slider}>
        <li className={styles.slide}>
          <Image
            alt="In-app chat list design prototype"
            src={slide1}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app share project design prototype"
            src={slide2}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app user profile design prototype"
            src={slide3}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app job details design prototype"
            src={slide4}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app payment design prototype"
            src={slide5}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app reviews design prototype"
            src={slide6}
            width={296}
            height={638}
          />
        </li>
        <li className={styles.slide}>
          <Image
            alt="In-app withdraw proposal design prototype"
            src={slide7}
            width={296}
            height={638}
          />
        </li>
      </ul>
    </div>
  );
}
